module.exports = __webpack_public_path__ + "static/media/license.36fb6dba.png";